import { ElevionLeafNode, ElevionNode } from 'lib-shared-types-api';

export const isLeafNode = (node: ElevionNode): node is ElevionLeafNode => {
  return 'comparator' in node;
};
